import type { IconProps } from "../types";

export const Table = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M12 3v18" />
    <rect width="18" height="18" x="3" y="3" />
    <path d="M3 9h18" />
    <path d="M3 15h18" />
  </svg>
);
